import { createStorefrontClient } from '@template-project/storefront-bff-client';
import { env } from '@/lib/utils/env';

function getClient() {
  return createStorefrontClient({
    baseUrl: env.STOREFRONT_BFF_URL,
    tenantId: env.FUNNELS_TENANT_ID,
  });
}

export async function subscribeToNewsletter(
  email: string,
  locale?: string,
): Promise<{ leadRef: string }> {
  const result = await getClient().captureLead({
    email,
    locale,
    lead_source: 'footer_newsletter',
  });
  return { leadRef: result.lead_ref };
}
